export default function downloadPdf(name, url) {
  const link = document.createElement("a");
  link.href = url;
  link.download = name; // Usar el nombre proporcionado
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
